import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'
import StorageService from '@/services/storage-service'
import MarketingService, { MARKETING_EVENTS } from '@/services/marketing-service'

function checkPaymentRedirection(to: Route, from: Route, next: NavigationGuardNext): void {
  const isAuthenticated = store.getters['auth/isAuthenticated']

  if (!isAuthenticated || from.name === to.name || to.hash === '#updated') return next()

  const lastPurchase = StorageService.getItem('okmenu_last_purchase', null, store.getters['auth/user']?.id)
  if (!lastPurchase) return next()

  const {
    route, plan, features, package: _package, addons, payment_method, source, renew, total,
  } = lastPurchase
  const succeed = to.name === 'payment:succeed'

  if (!succeed) {
    MarketingService.triggerEvent(MARKETING_EVENTS.PURCHASE_FAILED, 'purchase', 'user purchase failed', total, 1000).catch(() => {})
  }

  const query: any = {
    ...(route?.query ?? {}),
    ...(to?.query ?? {}),
    payment_method,
    plan: plan?.slug ?? _package?.slug,
    features: (features ?? addons ?? []).map((f: any) => f.slug).join(','),
    payment: succeed ? 'succeed' : 'failed',
  }

  if (renew) {
    query.renew = true
  }

  if (!route || ['upgrade', 'invoice', 'plans'].includes(source)) {
    // @ts-ignore
    return next({ name: to.name, hash: '#updated', query })
  }

  return next({
    ...route,
    query,
  })
}

export default checkPaymentRedirection
